import React from "react";

const COLORS = {
  "STRONG BUY":  { bg: "#052e16", border: "#16a34a", text: "#4ade80" },
  "BUY":         { bg: "#052e16", border: "#22c55e", text: "#86efac" },
  "HOLD":        { bg: "#0f172a", border: "#334155", text: "#64748b" },
  "SELL":        { bg: "#2d0a0a", border: "#dc2626", text: "#fca5a5" },
  "STRONG SELL": { bg: "#2d0a0a", border: "#991b1b", text: "#f87171" },
};

export default function SignalBadge({ action = "HOLD", size = "sm" }) {
  const c = COLORS[action] || COLORS["HOLD"];
  const pad = size === "lg" ? "5px 14px" : "2px 8px";
  const fs = size === "lg" ? 12 : 10;
  return (
    <span style={{
      background: c.bg,
      border: `1px solid ${c.border}`,
      color: c.text,
      borderRadius: 4,
      padding: pad,
      fontSize: fs,
      fontWeight: 700,
      letterSpacing: "0.05em",
      whiteSpace: "nowrap",
    }}>
      {action}
    </span>
  );
}
